import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { SkillFormItem } from '../../contactSchema';
import { defaultFormValues, skillCategoryEnum, skillLevelEnum } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const titleCase = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const CATEGORY_OPTIONS = [
  { value: '', label: '—' },
  ...skillCategoryEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: titleCase(v) })),
];

const LEVEL_OPTIONS = [
  { value: '', label: '—' },
  ...skillLevelEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: titleCase(v) })),
];

const empty = (): SkillFormItem => ({ name: '' });

export const SkillsSection = withForm({
  defaultValues: defaultFormValues,
  render: function SkillsSection({ form }) {
    return (
      <SectionCard
        title="Skills"
        actions={<AddItemButton onClick={() => form.pushFieldValue('skills', empty())} />}
      >
        <form.AppField name="skills">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove skill">
                  <div className="ds-form-grid-3">
                    <form.AppField name={`skills[${i}].name`}>
                      {(f) => <f.TextField label="Skill name" required />}
                    </form.AppField>
                    <form.AppField name={`skills[${i}].category`}>
                      {(f) => <f.Select label="Category" options={CATEGORY_OPTIONS} />}
                    </form.AppField>
                    <form.AppField name={`skills[${i}].level`}>
                      {(f) => <f.Select label="Level" options={LEVEL_OPTIONS} />}
                    </form.AppField>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
